import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $CenteredHeading = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${spacing('lg')};
`;

export const $BonusLine = styled.div`
  display: flex;
  gap: ${spacing('xxl')};
  padding: ${spacing('lg')};

  &:not(:last-child) {
    margin-bottom: ${spacing('lg')};
  }

  & a {
    padding-left: ${spacing(2.5)};
  }
  color: ${({ theme }) => theme.colors.mainTextColor};
  background-color: ${({ theme }) => theme.colors.headerTitleColor};
`;
